var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import localize from "@/utils/localization";
import { rethrowSimple } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationsCount',
    props: {
        workflow: null
    },
    setup(__props) {
        const props = __props;
        library.add(faList);
        const count = ref(undefined);
        function initCounts() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/workflows/{workflow_id}/counts", {
                    params: { path: { workflow_id: props.workflow.id } },
                });
                if (error) {
                    rethrowSimple(error);
                }
                let allCounts = 0;
                for (const stateCount of Object.values(data)) {
                    if (stateCount) {
                        allCounts += stateCount;
                    }
                }
                count.value = allCounts;
            });
        }
        onMounted(initCounts);
        return { __sfc: true, props, count, initCounts, faList, FontAwesomeIcon, localize };
    }
});
